import React from 'react'
import {
  FaArchive,
  FaExclamationTriangle,
  FaHome,
  FaPlusCircle,
  FaQuestionCircle,
  FaSignInAlt,
  FaSignOutAlt,
  FaUpload,
  FaUsers,
} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { match } from 'ts-pattern'
import { notifySuccess } from '../components/Notif'
import SidebarComponent from '../components/Sidebar/Sidebar'
import useCurrentUserStore, { getUserToken } from '../stores/currentUser'
import { whenRegExp } from '../utils'

function Sidebar() {
  const { removeCurrentUser, currentUser } = useCurrentUserStore()
  const navigate = useNavigate()
  const userToken = getUserToken()

  function handleLogout() {
    removeCurrentUser()
    navigate('/login')
    notifySuccess('Logout successfull')
  }

  function handleLogin() {
    navigate('/login')
  }

  const menus = [
    {
      icon: <FaHome />,
      label: 'Home',
      onClick: () => navigate('/'),
    },
    {
      icon: <FaPlusCircle />,
      label: 'Create Report',
      onClick: () => navigate('/laporan-pengaduan/create'),
    },
    ...match(currentUser?.data?.roles)
      .with(whenRegExp(/admin/), () => [
        {
          icon: <FaArchive />,
          label: 'Archive Reports',
          onClick: () => navigate('/laporan-pengaduan/archived'),
        },
        {
          icon: <FaExclamationTriangle color="red" />,
          label: 'Violation Reports',
          onClick: () => navigate('/laporan-pengaduan/violation'),
        },
        {
          icon: <FaUpload />,
          label: 'Handed Over Reports',
          onClick: () => navigate('/laporan-pengaduan/handed-over'),
        },
      ])
      .otherwise(() => []),
    ...match(currentUser?.data?.roles)
      .with('superadmin', () => [
        {
          icon: <FaUsers />,
          label: 'Users',
          onClick: () => navigate('/users'),
        },
      ])
      .otherwise(() => []),
    {
      icon: <FaQuestionCircle />,
      label: 'Help',
      onClick: () => {},
    },
    {
      icon: userToken ? <FaSignOutAlt /> : <FaSignInAlt />,
      label: userToken ? 'Logout' : 'Login',
      onClick: userToken ? handleLogout : handleLogin,
    },
  ]

  return (
    <SidebarComponent menus={menus} sx={{ display: ['none', null, 'block'] }} />
  )

  function archivePage() {
    if (currentUser?.data?.roles?.includes('admin')) {
      return [
        {
          icon: <FaArchive />,
          label: 'Archive Reports',
          onClick: () => navigate('/laporan-pengaduan/archived'),
        },
        {
          icon: <FaExclamationTriangle color="red" />,
          label: 'Violation Reports',
          onClick: () => navigate('/laporan-pengaduan/violation'),
        },
      ]
    } else {
      return []
    }
  }
}

export default Sidebar
